
export const MODULE_NAME = 'lk-home'

export const HOME_LK_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const
